<template>
  <div class="event-buttons">
    <v-btn-toggle>
      <v-btn
        v-if="event.dealt == 4"
        :to="{
          name: 'uploadFileShare',
          params: { id: $route.params.id, uploadFileId: event.id }
        }"
        color="info"
        small
        ><v-icon>share</v-icon></v-btn
      >
      <v-menu offset-y v-if="printer && event.document">
        <template v-slot:activator="{ on }">
          <v-btn color="info" dark v-on="on" small>
            <v-icon>print</v-icon>Print
          </v-btn>
        </template>
        <v-list>
          <v-list-tile
            v-if="event.document.path"
            @click="printDocumentWrapper(false)"
          >
            <v-list-tile-title>Original</v-list-tile-title>
          </v-list-tile>
          <v-list-tile
            v-if="event.document.pathCopy"
            @click="printDocumentWrapper(true)"
          >
            <v-list-tile-title>File copy</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-menu offset-y v-if="event.document">
        <template v-slot:activator="{ on }">
          <v-btn color="info" dark v-on="on" small>
            <v-icon>picture_as_pdf</v-icon>Download
          </v-btn>
        </template>
        <v-list>
          <v-list-tile v-if="event.document.path" @click="downloadLink(false)">
            <v-list-tile-title>Original</v-list-tile-title>
          </v-list-tile>
          <v-list-tile
            v-if="event.document.pathCopy"
            @click="downloadLink(true)"
          >
            <v-list-tile-title>File copy</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-btn
        v-if="event.document && event.document.type == 'document'"
        :to="{ name: 'documentEdit', params: { id: event.id } }"
        small
      >
        <v-icon>edit</v-icon>Edit
      </v-btn>
      <v-btn
        v-if="event.subType == 'email'"
        :to="{
          name: 'fileEmails',
          params: { id: $route.params.id },
          query: { id: event.id }
        }"
        small
      >
        <v-icon>edit</v-icon>View
      </v-btn>
      <v-btn @click="deleteEvent" color="error" small>
        <v-icon>delete</v-icon>
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
import UPLOAD_FILE_SIGNED_URL from "@/graphql/document/UploadFileSignedUrl";
export default {
  name: "Buttons",
  props: ["event", "printer"],
  methods: {
    async downloadLink(fileCopy) {
      if (this.event.document) {
        const type = this.event.document.type;
        if (type === "note") {
          window.open(
            `${process.env.VUE_APP_CT_URL}/cors/admin/file/notes/${this.event.id}/download`,
            "_blank"
          );
          // } else if (type == "eventold") {
        } else if (type === "document") {
          window.open(
            `${process.env.VUE_APP_CT_URL}/cors/admin/document/documents/${this.event.id}/${fileCopy}`,
            "_blank"
          );
        } else if (type === "upload") {
          const response = await this.$apollo.query({
            query: UPLOAD_FILE_SIGNED_URL,
            variables: { id: this.event.id }
          });
          window.open(response.data.uploadFile.upload.signedUrlGet, "_blank");
        }
      }
      return null;
    },
    printDocumentWrapper(fileCopy) {
      return `${fileCopy}`;
    },
    deleteEvent() {
      if (confirm("Are you sure?")) {
        this.$emit("delete", this.event);
      }
    }
  }
};
</script>

<style >
@media print {
  .event-buttons {
    display: none;
  }
}
</style>
